import "../../Ambition/index.css";
import solutionIcon from "../../../assets/ambition_icons/solutions-lab-icon.svg";
import "../../Ambition/components/AmbitionIntro/index.css";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import "../PartnershipsList/PartnershipsList.css";
import "./PartnershipDetail.css";
import featuredPartnerIcon from "../../../assets/partnership_icons/featured-partner.svg";
import {
  PartnershipDiscount,
  PartnershipFreeShipping,
} from "../PartnershipsList/PartnershipStamp";
import YFSSpecialOfferForm from "./YFSSpecialOfferForm";

const PartnershipDetail = () => {
  const location = useLocation();
  const [partnership, setPartnership] = useState(
    location.state?.partnership || null
  );

  const getCompanyLogo = () => {
    if (partnership?.documents && partnership.documents.length > 0) {
      const logoDoc = partnership.documents.find(
        (doc) => doc.document_type === "company_logo"
      );
      return logoDoc
        ? `https://res.cloudinary.com/azilisdjo/${logoDoc.file}`
        : null;
    }
    return null;
  };

  const getCertificateLogos = () => {
    if (partnership?.documents && partnership.documents.length > 0) {
      const certificateDocs = partnership.documents.filter(
        (doc) => doc.document_type === "certificate_logo"
      );
      return certificateDocs.map((doc) => ({
        id: doc.id,
        url: `https://res.cloudinary.com/azilisdjo/${doc.file}`,
        fileName: doc.file_name,
        uploadedAt: doc.uploaded_at,
      }));
    }
    return [];
  };

  const getFeaturedProductImage = (image) => {
    return image ? `https://res.cloudinary.com/azilisdjo/${image}` : null;
  };

  const logoUrl = getCompanyLogo();
  const certificateLogos = getCertificateLogos();

  return (
    <div className="ambition__body partnership-detail-container">
      <div
        style={{
          display: "flex",
          gap: "30.25px",
          paddingTop: "39px",
          marginBottom: "60px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <div
            className="ambition-intro-card-container"
            style={{ backgroundColor: "white", opacity: "95%" }}
          >
            <h5 style={{ fontWeight: "bold" }}>{partnership.company_name}</h5>
            <img
              src={logoUrl || solutionIcon}
              alt={logoUrl ? "Company Logo" : "Ambition Icon"}
              width={70}
              height={70}
              style={{ objectFit: "cover" }}
            />
          </div>
          {/* Business Details Section */}
          <div className="partnership-detail-item">
            <div
              style={{ fontSize: "12px", color: "#09366B", lineHeight: 1.6 }}
            >
              <div>{partnership.company_address_line1}</div>
              {partnership.company_address_line2 && (
                <div>{partnership.company_address_line2}</div>
              )}
              <div>VAT: {partnership.vat_number}</div>
              <div>{partnership.company_phone_number}</div>
              <div>{partnership.company_email}</div>
            </div>
          </div>
          {certificateLogos.length > 0 && (
            <div className="partnership-detail-item">
              <div className="certificate-logos-container">
                {certificateLogos.map((cert) => (
                  <img
                    key={cert.id}
                    src={cert.url}
                    alt={`Certificate: ${cert.fileName}`}
                    width={29}
                    height={30}
                    style={{ objectFit: "cover", margin: "5px" }}
                  />
                ))}
              </div>
            </div>
          )}

          {(partnership.free_shipping ||
            partnership.yfs_discount ||
            partnership.featured ||
            partnership.label) && (
            <div className="partnership-detail-item">
              <div className="partnership-badges-container">
                {(partnership.yfs_discount ||
                  partnership.free_shipping ||
                  partnership.label) && (
                  <PartnershipDiscount
                    partnership={partnership}
                    isDetail={true}
                  />
                )}
                {partnership.featured && (
                  <img
                    src={featuredPartnerIcon}
                    alt="Featured Partner Icon"
                    width={47}
                    height={28}
                  />
                )}
              </div>
            </div>
          )}
        </div>

        <div
          className="ambition-desc-box"
          style={{
            backgroundColor: "white",
            opacity: "95%",
            maxHeight: "fit-content",
          }}
        >
          <p className="ambition-desc-box-text" style={{ color: "#193666" }}>
            {partnership.company_description}
          </p>
        </div>
      </div>
      <div
        style={{ display: "flex", gap: "26.43px", alignItems: "flex-start" }}
      >
        <div className="partnership-detail-featured-products">
          {partnership.featured_products?.length > 0 &&
            partnership.featured_products.map((prod, index) => {
              return (
                <div
                  key={prod.id || index}
                  className="partnership-detail-featured-bg"
                >
                  <div className="partnership-detail-featured-img">
                    <img
                      src={getFeaturedProductImage(prod.image)}
                      alt={prod.product_name}
                      width={197.36}
                      height={103.36}
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                  <div className="partnership-detail-featured-name">
                    {prod.product_name}
                  </div>

                  <div className="partnership-detail-featured-desc">
                    {prod.product_description}
                  </div>

                  <div className="partnership-detail-featured-price">
                    {prod.individual_store_price ? (
                      <span style={{ fontStyle: "italic", color: "#f0f0f0" }}>
                        Individual store price
                      </span>
                    ) : (
                      `${prod.price} kr / ${prod.unit_qty} ${prod.unit}`
                    )}
                  </div>
                  <PartnershipDiscount
                    partnership={partnership}
                    isFeaturedProd={true}
                  />
                </div>
              );
            })}
        </div>
        <YFSSpecialOfferForm partnership={partnership} />
      </div>
    </div>
  );
};

export default PartnershipDetail;
